module.exports={
  "AirPurifier": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "Humidifier": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "Dehumidifier": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "AirConditioner": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "SystemAirConditioner": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "AirDresserx": {
    "textx": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "urlx": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "KimchiRefrigerator": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "WaterPurifier": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "ShoeDresser": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "LEDSignage": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "SMARTSignage": {
    "text": "Please <a href='https://www.samsung.com/uk/business/support/service-solutions/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/business/support/service-solutions/"
  },
  "AV": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "Range": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "Hood": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  },
  "UnSupported": {
    "text": "Please <a href='https://www.samsung.com/uk/support/contact/'>contact us</a> for more support with your product.",
    "url": "https://www.samsung.com/uk/support/contact/"
  }
}